var map = {
	"./program_01.png": 85881,
	"./program_02.png": 15599,
	"./program_03.png": 33618,
	"./program_04.png": 22363,
	"./program_05.png": 41075,
	"./program_06.png": 56757,
	"./program_07.png": 27860,
	"./program_08.png": 11874,
	"./program_09.png": 39250
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45343;